module.exports = __webpack_public_path__ + "static/img/tamabae_ka.5188566.jpg";